export default "__VITE_ASSET__BsB45H$5__"